import get from 'lodash/get';
import { NOTIFICACTIONS_MANAGER_STATE } from './constants';
import { getTrackingCode } from '~/tracking/utils';
import { BROWSER_ID } from '~/request/device/utils';
import { userCredentialsSelector } from './Authentication/selectors';
import { searchNotificationsSelector } from './SearchNotifications/selectors';
import { getCountryCode, getVerticalId } from '~/common/selectors/config';
import { getOrigin, getTrackingCodes, getUserIp } from '~/common/selectors/trovit';

export const trackingCodeByOriginSelector = state => {
  const trackingCodes = getTrackingCodes(state);
  const origin = getOrigin(state);

  const trackingCode = getTrackingCode(origin, trackingCodes);

  if (!trackingCode) {
    return null;
  }

  return trackingCode.code;
};

export const hasSearchNotificationsSelector = state => {
  const searchNotificatins = searchNotificationsSelector(state);
  return searchNotificatins.length !== 0;
};

export const notificationApiParamsSelector = state => {
  const { email, userControlToken } = userCredentialsSelector(state);
  const countryCode = getCountryCode(state);
  const verticalId = getVerticalId(state);
  const userIp = getUserIp(state);
  const trackingCode = trackingCodeByOriginSelector(state);
  const browserId = BROWSER_ID.mobile;

  return {
    emailAddress: email,
    control_value: userControlToken,
    country_code: countryCode,
    vertical_id: verticalId,
    ip: userIp,
    vv: trackingCode,
    browserId,
  };
};

export const confirmedDeletionSearchNotificationSelector = state => {
  const notificationsManagerState = state[NOTIFICACTIONS_MANAGER_STATE];
  return get(notificationsManagerState, 'confirmedDeletionSearchNotification');
};



// WEBPACK FOOTER //
// ./app/NotificationsManager/email/selectors.js